import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ITask } from '../../unit/interfaces/task.interface';
import { TaskCase } from '../interface/task.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class TaskService {
  readonly baseUrl = `${this.env.URL_API_V1}/task`;

  constructor(private readonly http: HttpClient, private env: EnvService) { }

  byCaseType(id) {
    return this.http.get<TaskCase[]>(`${this.baseUrl}/byCaseType/${id}`);
  }

  getTaskToGenerate(id, caseId) {
    return this.http.get<ITask[]>(`${this.baseUrl}/generateTasks/${id}/${caseId}`);
  }
  getTaskToGenerateByCaseType(id, caseId) {
    return this.http.get<ITask[]>(`${this.baseUrl}/generateTasksBycaseType/${id}/${caseId}`);
  }
}
